import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';

import IconCheckSome from '@/assets/svg/icon-selected-some.svg?react';

import { cn } from '@/lib/utils';

const CheckboxSome = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50  data-[state=checked]:text-neutral-50',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn('flex items-center justify-center text-current')}
    >
      <IconCheckSome />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
CheckboxSome.displayName = CheckboxPrimitive.Root.displayName;

export { CheckboxSome };
